import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@hooks/useAuth';
import { useVIPStatus } from '@hooks/useVIPStatus';
import { isMobile } from '@utils/helpers';
import SearchOverlay from './SearchOverlay';

function Header() {
    const { user, isLoggedIn, logout } = useAuth();
    const { isVIP } = useVIPStatus();
    const navigate = useNavigate();
    const [showMobileMenu, setShowMobileMenu] = useState(false);
    const [showSearch, setShowSearch] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [isMobileView, setIsMobileView] = useState(isMobile());

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(isMobile());
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleLogout = () => {
        logout();
        setShowMobileMenu(false);
        navigate('/');
    };

    const toggleMobileMenu = () => {
        setShowMobileMenu(!showMobileMenu);
    };

    const toggleSearch = () => {
        setShowSearch(!showSearch);
    };

    const username = user?.username || user?.email?.split('@')[0] || 'User';

    return (
        <>
            <header className="header">
                <div className="header-content">
                    {/* Mobile left: search button */}
                    <div className="mobile-left mobile-only">
                        <button
                            id="searchToggleBtn"
                            className="search-toggle"
                            aria-label="Cari"
                            onClick={toggleSearch}
                        >
                            <i className="fas fa-search"></i>
                        </button>
                    </div>

                    {/* Logo */}
                    <h1 className="logo">
                        <Link to="/" style={{ textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                            <i className="fas fa-play-circle"></i>
                            DinoShort
                        </Link>
                    </h1>

                    {/* Search Container (Desktop) */}
                    <div className={`search-container ${showSearch ? 'open' : ''}`}>
                        <div className="search-box">
                            <input
                                type="text"
                                id="searchInput"
                                placeholder="Cari drama favorit..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                onFocus={() => setShowSearch(true)}
                            />
                            <button onClick={() => setShowSearch(true)}>
                                <i className="fas fa-search"></i>
                            </button>
                        </div>
                    </div>

                    {/* Auth Actions */}
                    <div className="auth-actions">
                        {!isLoggedIn ? (
                            <div className="guest-menu">
                                <Link className="auth-btn desktop-only" to="/login">Masuk</Link>
                                <Link className="auth-btn primary desktop-only" to="/register">Daftar</Link>
                                <Link className="auth-btn vip-btn desktop-only" to="/vip">🏆 VIP</Link>
                            </div>
                        ) : (
                            <div className="user-menu" style={{ display: 'flex' }}>
                                <Link
                                    to="/profile"
                                    className="user-status-badge desktop-only"
                                    title={isVIP ? 'VIP User' : 'Regular User'}
                                >
                                    {isVIP ? '🏆' : '👤'}
                                </Link>
                                <Link
                                    to="/profile"
                                    className="user-name desktop-only"
                                    title="Lihat Profil"
                                >
                                    {username}
                                </Link>
                                <Link className="auth-btn vip-btn desktop-only" to="/vip">🏆 VIP</Link>
                                <Link className="auth-btn desktop-only" to="/redeem" title="Redeem Code">🎟️</Link>
                                <button
                                    className="auth-btn logout-btn desktop-only"
                                    onClick={handleLogout}
                                >
                                    Logout
                                </button>
                            </div>
                        )}

                        {/* Mobile Hamburger */}
                        <button
                            id="mobileMenuBtn"
                            className="hamburger mobile-only"
                            aria-label="Menu"
                            onClick={toggleMobileMenu}
                        >
                            <span></span>
                            <span></span>
                            <span></span>
                        </button>
                    </div>
                </div>
            </header>

            {/* Mobile Menu */}
            <nav id="mobileMenu" className={`mobile-menu ${showMobileMenu ? 'open' : ''}`}>
                {!isLoggedIn ? (
                    <>
                        <Link to="/login" className="mobile-menu-item" onClick={() => setShowMobileMenu(false)}>Masuk</Link>
                        <Link to="/register" className="mobile-menu-item primary" onClick={() => setShowMobileMenu(false)}>Daftar</Link>
                        <Link to="/vip" className="mobile-menu-item" onClick={() => setShowMobileMenu(false)}>
                            <i className="fas fa-crown"></i> VIP
                        </Link>
                    </>
                ) : (
                    <>
                        <div className="mobile-menu-item" style={{ padding: '15px', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <span style={{ fontSize: '1.2em' }}>{isVIP ? '🏆' : '👤'}</span>
                                <span style={{ color: '#d4af37', fontWeight: 'bold' }}>{username}</span>
                            </div>
                            <div style={{ fontSize: '0.8em', color: '#999', marginTop: '2px' }}>
                                {isVIP ? 'VIP User' : 'Regular User'}
                            </div>
                        </div>
                        <Link to="/profile" className="mobile-menu-item" onClick={() => setShowMobileMenu(false)}>
                            <i className="fas fa-user"></i> Profil
                        </Link>
                        <Link to="/vip" className="mobile-menu-item" onClick={() => setShowMobileMenu(false)}>
                            <i className="fas fa-crown"></i> VIP
                        </Link>
                        <Link to="/redeem" className="mobile-menu-item" onClick={() => setShowMobileMenu(false)}>
                            <i className="fas fa-ticket-alt"></i> Redeem Code
                        </Link>
                        <button
                            onClick={handleLogout}
                            className="mobile-menu-item"
                            style={{ width: '100%', textAlign: 'left', background: 'none', border: 'none', color: '#ff6b6b' }}
                        >
                            <i className="fas fa-sign-out-alt"></i> Logout
                        </button>
                    </>
                )}
            </nav>

            {/* Search Overlay */}
            <SearchOverlay
                isOpen={showSearch}
                onClose={() => setShowSearch(false)}
                query={searchQuery}
                onQueryChange={setSearchQuery}
            />
        </>
    );
}

export default Header;
